var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history-tabbar"},_vm._l((_vm.historyTabList),function(item,index){return _c('div',{key:index,class:['tab',_vm.currentIndex == index?'active':'' ],on:{"click":function($event){return _vm.changeActiveIndex(index)}}},[_vm._v(" "+_vm._s(item.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }